import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import 'antd/dist/reset.css'
import './styles/tokens.css'
import { ConfigProvider } from 'antd'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './context/auth-context'
import { ProcessProvider } from "./context/ProcessContext";
import { trendyTheme } from './theme/tokens'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider theme={trendyTheme}>
      <Router>
        <AuthProvider>
          <ProcessProvider>
            <App />
          </ProcessProvider>
        </AuthProvider>
      </Router>
    </ConfigProvider>
  </React.StrictMode>
)
